import { useMemo, MouseEvent } from 'react';
import Checkbox from '../../../../general-ui/checkbox/checkbox';
import Icon, { COLORS, ICONS } from '../../../../general-ui/icon';
import { Sponsor } from '../../../../../types/working-model';
import classNames from 'classnames';

interface Props {
	sponsor: Sponsor;
	onClick: (sponsor: Sponsor, isOn: boolean) => void;
	selected: any[];
	editSponsor: (sponsor: Sponsor) => () => void;
}

export default function AddSponsor(props: Props): JSX.Element {
	const {
		sponsor,
		selected,
		onClick,
		editSponsor
	} = props;

	function handleChange(e: any, isOn: boolean) {
		onClick(sponsor, isOn);
	}

	const isSelected = useMemo(() => {
		return selected.includes(sponsor.sponsor);
	}, [selected, sponsor.sponsor]);

	function handleEdit() {
		editSponsor(sponsor)();
	}
	
	return (
		<div className="add-sponsor">
			<div
				className={classNames("image-container", {selected: isSelected})}
				style={{ backgroundImage: `url(${sponsor.image.replace(/\s/g, '%20')})` }}
				onClick={(e: MouseEvent) => {
					handleChange(sponsor, !isSelected);
					e.stopPropagation();
				}}
			>
				<div className="sponsor-controls">
					<Checkbox
						checked={isSelected}
						onChange={handleChange}
						value={sponsor.name}
						size={20}
						color={isSelected ? COLORS.CYAN : COLORS.WHITE}
						backgroundColor={isSelected ? COLORS.WHITE : undefined}
						selectedIconName={ICONS.CHECKBOX_BORDERLESS}
					/>
					<div className="actions">
						<button onClick={(e: MouseEvent) => {
							// when clicking edit, fire the parent onClick
							e.stopPropagation();
							handleEdit();
						}} className="no-style edit-button"><Icon name={ICONS.EDIT} size={20} color={COLORS.WHITE} /></button>
					</div>
				</div>
			</div>
			<h6>{sponsor.name}</h6>
		</div>
	);
}
